import script from "./General.vue?vue&type=script&setup=true&lang=ts"
export * from "./General.vue?vue&type=script&setup=true&lang=ts"

import "./General.vue?vue&type=style&index=0&id=22d15fe3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d15fe3"]])

export default __exports__